import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; 

import authSlice from './auth/authSlice'; 
 
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['login'], 
};

const rootReducer = combineReducers({
  auth: authSlice,
  // registration:registrationSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

export const persistor = persistStore(store);
